<template>
    <CustomerListOrderFormPage1
        v-bind="$attrs"
        v-on="$listeners"
    />
</template>

<script>
    import CustomerListOrderFormPage1 from "../CustomerListOrderForm/CustomerListOrderFormPage1";

    export default {
        components: {
            CustomerListOrderFormPage1,
        },
    }
</script>
